import React, { Component } from "react";
import { connect } from "react-redux";
import { confirmAlert } from "react-confirm-alert";
import { Modal, Form, FormControl, FormGroup, Button, HelpBlock } from "react-bootstrap";
import Select from "react-select";
import { rejectApplication } from "../../actions";

class MentorRow extends Component {
	state = {
		value: null,
		disabled: false,
		show: false,
		comment: "",
	};

	componentDidMount() {
		const { row } = this.props;
		this.checkStateRow(row);
	}

	componentDidUpdate(prevProps) {
		const { row } = this.props;
		if (prevProps.row.mentor_email !== row.mentor_email) {
			this.checkStateRow(row);
		}
	}

	checkStateRow = (row) => {
		if (typeof row.mentor_email === "string" && row.mentor_email.length > 0) {
			this.setState({ value: row.mentor_email, disabled: true });
		} else if (!row.mentor_email) {
			this.setState({ disabled: false, value: null });
		}
	};

	onChange = (event) => {
		this.setState({ value: event ? event.value : null });
	};

	setValue = (row) => () => {
		const { value } = this.state;
		const { setMentor } = this.props;
		if (typeof value === "string" && value.length > 0 && Number(row.process_id) > 0) {
			setMentor(row.process_id, value, this.onChange);
		}
	};

	handleShow = () => {
		this.setState({ show: true });
	};

	handleClose = () => {
		this.setState({ show: false, comment: "" });
	};

	handleChange = (event) => {
		this.setState({ comment: event.target.value });
	};

	handleSubmit =
		({ process_id }) =>
		(event) => {
			event.preventDefault();

			const length = this.state.comment.length;
			if (length >= 50 && length <= 1500) {
				this.props.onRejectApplication(process_id, event.target.comment.value);
				this.handleClose();
			} else {
				confirmAlert({
					message: "Минимальная длина комментария 50 символов.",
					buttons: [
						{
							label: "Продолжить",
							// eslint-disable-next-line @typescript-eslint/no-empty-function
							onClick: () => {},
						},
					],
				});
			}
		};

	getValidationState = () => {
		const length = this.state.comment.length;
		if (length >= 50 && length <= 1500) return "success";
		if (length > 0 && (length < 50 || length > 1500)) return "error";
		return null;
	};

	render() {
		const { mentors, row, settingMentorIsDisable = false } = this.props;
		const selectedMentor = mentors.find((mentor) => mentor.sk_user_email === row.mentor_email);

		return !row.mentor_confirmed && !settingMentorIsDisable ? (
			<div
				className="input-group"
				onClick={(event) => event.stopPropagation()}
				style={{ display: "flex", flexDirection: "column" }}
			>
				<Select
					autosize={false}
					name="form-field-name"
					className="has-success"
					placeholder="Выбрать исполнителя"
					value={this.state.value}
					disabled={!!this.state.disabled}
					style={{ width: "100%", borderColor: "#ccc" }}
					onChange={this.onChange}
					options={mentors.map((mentor) => ({
						value: mentor.sk_user_email,
						label: [mentor.mentor_last_name, mentor.mentor_first_name].join(" "),
					}))}
				/>
				{this.state.disabled ? (
					<button
						type="button"
						className="btn btn-default"
						style={{ width: "100%" }}
						onClick={() => this.setState({ disabled: false })}
					>
						Переназначить
					</button>
				) : (
					<button type="button" className="btn btn-success" onClick={this.setValue(row)}>
						Назначить
					</button>
				)}
				<button type="button" className="btn btn-danger" onClick={this.handleShow}>
					Отклонить заявку
				</button>

				<Modal bsSize="lg" show={this.state.show} onHide={this.handleClose}>
					<Modal.Header closeButton={this.handleClose}>
						<Modal.Title>Причина отклонения</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<Form onSubmit={this.handleSubmit(row)}>
							<FormGroup controlId="formBasicText" validationState={this.getValidationState()}>
								<FormControl
									style={{ minHeight: "200px" }}
									bsSize="lg"
									componentClass="textarea"
									placeholder="Пожалуйста, напишите причину отклонения"
									value={this.state.comment}
									onChange={this.handleChange}
									maxLength="1500"
									name="comment"
									required
								/>
								<HelpBlock>Минимальная длина комментария 50 символов.</HelpBlock>
							</FormGroup>
							<Modal.Footer>
								<Button type="submit" className="btn btn-success">
									Отправить
								</Button>
								<Button onClick={this.handleClose}>Закрыть</Button>
							</Modal.Footer>
						</Form>
					</Modal.Body>
				</Modal>
			</div>
		) : (
			<div>{selectedMentor ? [selectedMentor.mentor_last_name, selectedMentor.mentor_first_name].join(" ") : ""}</div>
		);
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		onRejectApplication: (process_id, comment) => dispatch(rejectApplication(process_id, comment)),
	};
};

export default connect((state) => state, mapDispatchToProps)(MentorRow);
